import { DISCOUNT_NOTES } from '~/lib/constants/constants'
import { css, sva } from '~/styled-system/css'
import { useIsTimeSaleLabelVisible, useShowTimeSaleText } from '../../store/notes'
import { usePlan, useRestaurant } from '../../store/stateMachine/state'

const styles = sva({
  slots: ['container', 'note'],
  base: {
    container: {
      py: '2',
      fontSize: 'base',
      wordBreak: 'break-all',
      _pc: {
        spaceY: '4',
      },
    },
    note: {
      whiteSpace: 'pre-wrap',
    },
  },
})

export function NotesBody() {
  const { plan, restaurant, showTimeSaleText } = useNotesBody()
  if (plan === undefined || restaurant === undefined) {
    return null
  }
  if (plan.notes === '' && restaurant.notes === '' && !showTimeSaleText) {
    return <p className={css({ fontSize: 'base' })}>なし</p>
  }
  const classes = styles()
  return (
    <div className={classes.container}>
      {restaurant.notes && <pre className={classes.note}>{restaurant.notes}</pre>}
      {plan.notes && <pre className={classes.note}>{plan.notes}</pre>}
      {showTimeSaleText && <TimeSaleText />}
    </div>
  )
}

function useNotesBody() {
  const plan = usePlan()
  const restaurant = useRestaurant()
  const showTimeSaleText = useShowTimeSaleText()
  return { plan, restaurant, showTimeSaleText }
}

function TimeSaleText() {
  const isLabelVisible = useIsTimeSaleLabelVisible()
  return (
    <>
      {isLabelVisible && (
        <p>※タイムセールのプランについて、期間や割引率は予告なく変更となる場合があります。</p>
      )}
      <p>{DISCOUNT_NOTES}</p>
    </>
  )
}
